<template>
  <div>
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                供货单位：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.supplyUnit }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订货单位：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.orderUnit }}（{{ info.orderUnitCode }}）
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                最终客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.finalCustomer }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                币种：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                合同日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.createTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.orderSales }}{{ info.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实际结算金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.actualSettlementAmount }}{{ info.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                预付款比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.prepaymentRatioNum }}%
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.assignAll }}{{ info.currencyName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.proportion }}%
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                未分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ info.unAssignAll }}{{ info.currencyName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" height="500">
        <el-table-column type="index" width="50" label="序号" align="left" />
        <el-table-column prop="telegraphicTransferNo" label="电汇底单编号" align="left" />
        <el-table-column prop="remittanceAmount" label="汇款金额" align="right" header-align="left" width="" />
        <el-table-column prop="remittanceTime" label="汇款日期" align="left" width="" />
        <el-table-column prop="importAccount" label="汇入账户" align="left" width="" />
        <el-table-column prop="importCompany" label="汇入公司" align="left" />
        <el-table-column prop="remark" label="摘要" align="left" />
        <el-table-column prop="usedAmount" label="已使用金额" align="right" header-align="left" />
        <el-table-column prop="availableAmount" label="可用余额" align="right" header-align="left" />
        <el-table-column prop="assignAmount" label="本次分配金额" align="right" header-align="left">
          <template v-slot="{row}">
            <el-input-number v-model="row.assignAmount" style="width:100%;" :precision="2" :min="0" label="描述文字" @change="assignBlur(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-button type="primary" style="margin-top:20px" @click="submitData">
      确认分配
    </el-button>

    <span>
      本次分配金额：<span class="money">{{ assignAllTotal.toFixed(2) }} {{ info.currencyName }}</span>
    </span>

    <sureAAllocation :info="info" :assign-all-total="assignAllTotal" :dialog-form-visible="dialogFormVisible" :data="sureData" @on-status-dialog="onstatus" />
  </div>
</template>

<script>
import { getContractDetailAllInfoByConNum, listAssignTelegraphicTransferInternationBusiness } from '@/API/index.js';
import { numAdd } from '@/libs/util';
import sureAAllocation from './sureAAllocation';
export default {
  components: {
    sureAAllocation
  },

  data () {
    return {
      info: {
        unAssignAll: 0
      },
      dialogFormVisible: false,
      loading: false,
      tableData: [],
      tableLoading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      }
    };
  },

  computed: {
    assignAllTotal () {
      let total = 0;
      this.tableData.forEach((item) => {
        total = numAdd(item.assignAmount ? item.assignAmount : 0, total);
      });
      return total;
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    async initData () {
      let contractNum = this.$route.query.contractNum;

      // 详情
      const resInfo = await getContractDetailAllInfoByConNum(contractNum);
      let { status, data } = resInfo.data;
      if (status === '200') {
        this.info = data;
      }

      // 列表
      listAssignTelegraphicTransferInternationBusiness({
        contractNum: contractNum,
        currency: this.info.currencyId
      }).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          data.list.forEach((item) => { item.assignAmount = 0; });
          this.tableData = data.list;
        }
      });
    },
    onstatus (val) {
      this.dialogFormVisible = val;
      if (!val) {
        this.initData();
      }
    },
    // 提交分配
    submitData () {
      this.sureData.dialogData = JSON.parse(JSON.stringify(this.tableData));

      this.sureData.dialogData.forEach((item) => {
        item.contractNum = this.info.contractNum;
        item.actualSettlementAmount = this.info.actualSettlementAmount;
      });

      // 过滤本次分配金额不为0 的
      let resData = this.sureData.dialogData.filter((item) => {
        return item.assignAmount > 0;
      });

      this.sureData.dialogData = resData;
      this.dialogFormVisible = true;
    },

    // 验证输入金额
    assignBlur (row) {
      if (row.unusedAmount < row.assignAmount) {
        row.assignAmount = row.unusedAmount;
      }
      if (row.assignAmount > row.availableAmount) {
        row.assignAmount = row.availableAmount;
      }
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount > 0) {
          num = numAdd(num, item.assignAmount);
        }
      });
      if (num > this.info.actualSettlementAmount) {
        this.$message.warning('本次分配金额大于未分配金额，请进行调整');
        row.assignAmount = 0;
      }
    }

  }
};
</script>

<style lang="scss" scoped>

</style>
